import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { getSignIn, getUserInfo, getVerifyInfo } from "../library/api";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useCookies } from "react-cookie";

const Login = () => {
  const [cookies, setCookie, removeCookie] = useCookies(["remember"]);

  const navigate = useNavigate();
  const [saveId, setSaveId] = useState(false);
  const [value, setValue] = useState({ id: "", password: "" });

  // 퍄트너스 회원 정보 가져오기
  const { mutate: getUserInfoMutate } = useMutation({
    mutationFn: getUserInfo,
    mutationKey: ["getUserInfo"],
    onSuccess: (data) => {
      //    setUserInfo(data);
      if (saveId) {
        // 아이디 저장
        setCookie("remember", value.id, { maxAge: 2000 });
      } else {
        // 아이디 저장 안함
        removeCookie("remember");
      }
      navigate("/period-report");
    },
    onError: (error) => {
      alert(error.response.data.message);
      throw error;
    },
  });

  // 로그인
  const { mutate: getSignInMutate } = useMutation({
    mutationFn: getSignIn,
    mutationKey: ["getSignIn"],
    onSuccess: (data) => {
      if (data.done === true) {
        getUserInfoMutate();
        localStorage.setItem("admin_token", data.token);
      }
    },
    onError: (error) => {
      alert(error.response.data.message);
      throw error;
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevents default form submission behavior
    if (value.id === "") {
      alert("아이디를 입력해주세요");
      return;
    }

    if (value.password === "") {
      alert("비밀번호를 입력해주세요");
      return;
    }
    getSignInMutate(value);
  };

  useEffect(() => {
    const items = cookies.remember;
    if (items !== undefined) {
      setSaveId(true);
      setValue({ id: items, password: "" });
    }
  }, []);
  return (
    <main className="flex-grow container mx-auto px-4 py-10 sm:py-20 min-h-[80%]">
      <div className="max-w-md mx-auto">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-center mb-2">
          로그인
        </h1>
        <p className="text-center text-sm mb-8 sm:mb-10">
          일사 파트너스 서비스를 위해 로그인이 필요합니다.
        </p>
        <form
          id="loginForm"
          className="flex flex-col items-center"
          onSubmit={handleSubmit}
        >
          <div className="mb-2.5 w-full">
            <input
              type="text"
              placeholder="아이디"
              className="w-full px-4 py-3 sm:py-4 border border-gray-300 rounded-lg outline-none"
              value={value?.id}
              onChange={(e) => {
                setValue((prevState) => ({ ...prevState, id: e.target.value }));
              }}
            />
          </div>
          <div className="mb-6 sm:mb-8 w-full">
            <input
              type="password"
              placeholder="비밀번호"
              className="w-full px-4 py-3 sm:py-4 border border-gray-300 rounded-lg outline-none"
              onChange={(e) => {
                setValue((prevState) => ({
                  ...prevState,
                  password: e.target.value,
                }));
              }}
            />
          </div>
          <div className="w-full flex justify-between items-center mb-8 sm:mb-10">
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={saveId}
                id="remember"
                onChange={(event) => setSaveId(event.target.checked)}
                className="mr-2 appearance-none rounded-full border border-gray-400 w-5 h-5 checked:bg-blue-600 checked:border-none checked:bg-check checked:bg-center"
              />
              <label htmlFor="remember" className="font-medium text-sm">
                아이디 저장
              </label>
            </div>
            <div>
              <a
                onClick={() => navigate("/find-id")}
                className="font-medium text-sm"
              >
                아이디 찾기
              </a>
              <span className="text-gray-500 mx-1"> | </span>
              <a
                onClick={() => navigate("/find-pw")}
                className="font-medium text-sm"
              >
                비밀번호 재설정
              </a>
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-teal-500 font-extrabold text-lg text-white py-3 sm:py-4 rounded-full hover:bg-teal-600 transition duration-300"
          >
            로그인
          </button>
        </form>
      </div>
    </main>
  );
};

export default Login;
